/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetOwnTimeOffContextRequest} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'
import {GetOwnTimeOffContextResponse} from '@cash-web/protos/squareup/timecards/scheduling/service.pb'


export const getOwnTimeOffContext = (request: GetOwnTimeOffContextRequest, options?: CashRequestOptions) => post<GetOwnTimeOffContextRequest, GetOwnTimeOffContextResponse>("/2.0/cash/get-own-time-off-context", request, {...options, rejectOnError: true })